import { Component, inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import {
  ButtonComponent,
  ButtonVariant,
} from "src/app/common/components/core/button/button.component";

@Component({
  selector: "app-session-expired",
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: "./session-expired.component.html",
  styleUrls: ["./session-expired.component.scss"],
})
export class SessionExpiredComponent {
  private _dialogRef = inject(MatDialogRef<SessionExpiredComponent>);
  buttonVariant = ButtonVariant;
  close() {
    this._dialogRef.close();
  }
}
